import { render, staticRenderFns } from "./InternalLBAssignVmForm.vue?vue&type=template&id=781f9582&scoped=true&"
import script from "./InternalLBAssignVmForm.vue?vue&type=script&lang=js&"
export * from "./InternalLBAssignVmForm.vue?vue&type=script&lang=js&"
import style0 from "./InternalLBAssignVmForm.vue?vue&type=style&index=0&id=781f9582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781f9582",
  null
  
)

export default component.exports